module.exports = __webpack_public_path__ + "static/img/icon_3.e3e4d38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_3.png
// module id = lRVM
// module chunks = 0